import React from 'react';
import { createPortal } from 'react-dom';
import './modal.css';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
    this.backdropRef = React.createRef();
  }

  componentDidMount() {
    // Only set up modal behavior if it's open
    if (this.props.isOpen) {
      this.setupModal();
    }
  }

  componentDidUpdate(prevProps) {
    // Handle modal open/close state changes
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setupModal();
    } else if (!this.props.isOpen && prevProps.isOpen) {
      this.cleanupModal();
    }
  }

  componentWillUnmount() {
    // Always cleanup when component unmounts
    this.cleanupModal();
  }

  setupModal = () => {
    // Focus the modal when it opens for accessibility
    if (this.modalRef.current) {
      this.modalRef.current.focus();
    }
    
    // Add event listener for Escape key
    document.addEventListener('keydown', this.handleKeyDown);
    
    // Prevent body scrolling when modal is open
    document.body.style.overflow = 'hidden';
  };

  cleanupModal = () => {
    // Remove event listener
    document.removeEventListener('keydown', this.handleKeyDown);
    
    // Restore body scrolling
    document.body.style.overflow = 'unset';
  };

  handleKeyDown = (event) => {
    // Close modal on Escape key
    if (event.key === 'Escape') {
      this.props.onClose();
    }
  };

  handleBackdropClick = (event) => {
    // Close modal when clicking on backdrop (not the modal content)
    if (event.target === this.backdropRef.current) {
      this.props.onClose();
    }
  };

  render() {
    if (!this.props.isOpen) {
      return null;
    }

    return createPortal(
      <div 
        className="modal-backdrop" 
        ref={this.backdropRef}
        onClick={this.handleBackdropClick}
      >
        <div 
          className="modal-container"
          ref={this.modalRef}
          tabIndex={-1}
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title"
        >
          <button 
            className="modal-close-button"
            onClick={this.props.onClose}
            aria-label="Close modal"
          >
            ×
          </button>
          <div className="modal-content">
            {this.props.children}
          </div>
        </div>
      </div>,
      document.body
    );
  }
}

export default Modal;
